async function initDialogs() {
  if (!('HTMLDialogElement' in window)) {
    const [{ default: dialogPolyfill }] = await Promise.all([
      import('dialog-polyfill'),
      import('dialog-polyfill/dist/dialog-polyfill.css'),
    ]);

    document.querySelectorAll('dialog').forEach((dialog) => {
      dialogPolyfill.registerDialog(dialog);
    });
  }
}

initDialogs();